<div v-if="shouldRenderConfig && getIsCimpressProduct" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-on:click="resetButton">
        {{ $t(name) }}
    </button>
</div>